import { useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Input } from '@nazka/nazka.mapframe.components';

import EditableImage from '@App/components/EditableImage/EditableImage';
import { useAdaptationPlans } from '@services/query.service';
import { useTranslation } from '@utils/i18n/i18n.consumers';
import { getImageUrl } from '@services/utils.service';
import { useUpdateAdaptationPlan } from '@services/mutation.service';

import AdminEditPlanForm from './AdminEditPlanForm/AdminEditPlanForm';
import AdminMap from '../AdminMap/AdminMap';
import AdminStatusBadge from '../AdminStatusBadge/AdminStatusBadge';

import './admin-edit-plan.styl';

function AdminEditPlan() {
  const [updatedImage, setUpdatedImage] = useState();

  const { t } = useTranslation();
  
  const { data: adaptationPlans } = useAdaptationPlans();

  const { id } = useParams();
  const navigate = useNavigate();

  const plan = useMemo(() => adaptationPlans?.find(s => s.id === id), [id, adaptationPlans]);

  const updateAdaptationPlanMutation = useUpdateAdaptationPlan();

  function handleSubmit(payload) {
    const formData = new FormData();

    Object.keys(payload).forEach((key) => {
      if (['translations', 'hazardCategories'].includes(key)) {
        formData.append(key, JSON.stringify(payload[key]));
      } else {
        formData.append(key, payload[key]);
      }
    });

    if (updatedImage) {
      formData.append('image', updatedImage, updatedImage.name);
    }

    updateAdaptationPlanMutation.mutate({
      id,
      data: formData,
    });
  }

  if (!plan) {
    return null;
  }

  return (
    <div className="admin-edit-plan">
      <h2>
        {t('Edit - {{title}}', { title: plan.translations.en.title })}
        <AdminStatusBadge status={plan.status} />
      </h2>
      <div className="admin-edit-plan__content">
        <AdminEditPlanForm
          plan={plan}
          onSuccess={handleSubmit}
          onCancel={() => navigate('/admin/plans')}
          isPending={updateAdaptationPlanMutation.isPending}
        /> 
        <div className="admin-edit-plan__content__rest">
          <div className="admin-edit-plan__content__rest__field">
            <label htmlFor="creatorName">
              {t('Name of creator')}
            </label>
            <Input
              disabled
              rootElProps={{
                id: 'creatorName',
              }}
              value={plan.creatorName}
            />
          </div>
          <div className="admin-edit-plan__content__rest__field">
            <label htmlFor="address">
              {t('Adaptation plan address')}
            </label>
            <Input
              disabled
              rootElProps={{
                id: 'address',
              }}
              value={plan.address}
            />
          </div>
          <AdminMap item={plan} />
          <EditableImage
            src={getImageUrl(plan)}
            alt={plan.translations.en.title}
            onImageChange={file => setUpdatedImage(file)}
          />
        </div>
      </div>
    </div>
  );
}

export default AdminEditPlan;